import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { exportObeDetailsDownloadUrl } from 'constants/urls';
import downloadBlob from 'utils/download/downloadBlob';
import isNorwegian from 'utils/language/isNorwegian';
export default function useExportObes() {
  const [downloadIsLoading, setDownloadIsLoading] = useState(false);
  const {
    t,
    i18n
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const downloadObeDetails = async customerId => {
    try {
      setDownloadIsLoading(true);
      const url = exportObeDetailsDownloadUrl(customerId);
      const today = new Date().toISOString().slice(0, 10);
      const body = {
        isNorwegian: isNorwegian(i18n)
      };
      return await downloadBlob(url, `OBE-Details-Report-${today}.csv`, 'POST', body);
    } catch (e) {
      console.error(e);
      const message = t('error.export_obe_details');
      enqueueSnackbar(message, {
        variant: 'error'
      });
    } finally {
      setDownloadIsLoading(false);
    }
  };
  return {
    downloadObeDetails,
    downloadIsLoading
  };
}